import calculatePayment from './calculatePayment';
import round from './round';

/**
 * Early Payoff Calculator
 * @param {Number} principal Remaining balance in dollars
 * @param {Number} interestRate Annual interest rate (ex: 8.5)
 * @param {Number} currentPayment Current montly payment in dollars
 * @param {Number} numberOfYears Number of years ideally to pay off mortgage
 */
export function earlyPayoffCalculator(
  principalBalance,
  interestRate,
  currentPayment,
  numberOfYears
) {
  const monthlyInterestRate = interestRate / 100 / 12;
  const newPayoffMonths = numberOfYears * 12.0;
  const newMonthlyPayment = calculatePayment(
    principalBalance,
    monthlyInterestRate,
    newPayoffMonths
  );

  // Handle error
  if (newMonthlyPayment <= currentPayment) {
    return {
      currentPayoffYears: 0,
      newPayoffYears: 0,
      currentInterestCost: 0,
      newInterestCost: 0,
      totalInterestSavings: 0,
      additionalMonthlyFunds: 0,
      error:
        'Given the terms you entered your mortgage is already scheduled to be paid off in less than ' +
        numberOfYears +
        ' years.',
    };
  }

  let currentCount = 0;
  let currentPrincipal = principalBalance;
  let currentAccumulativeInterest = 0;
  while (currentPrincipal > currentPayment) {
    let interestPayment = monthlyInterestRate * currentPrincipal;
    currentAccumulativeInterest += interestPayment;
    currentPrincipal -= currentPayment - interestPayment;
    currentCount++;

    // Failsafe
    if (currentCount > 780) {
      return {
        currentPayoffYears: 0,
        newPayoffYears: 0,
        currentInterestCost: 0,
        newInterestCost: 0,
        totalInterestSavings: 0,
        additionalMonthlyFunds: 0,
        error:
          'At the terms you entered your mortgage will never be paid off. Please either reduce the principal, reduce the interest rate, increase the payment amount, or a combination of all three.',
      };
    }
  }

  const currentPayoffYears = round(currentCount / 12.0);
  const newPayoffYears = numberOfYears;
  const currentInterestCost = round(currentAccumulativeInterest);
  const newInterestCost = round(
    newMonthlyPayment * newPayoffMonths - principalBalance
  );
  const totalInterestSavings = round(
    currentAccumulativeInterest -
      (newMonthlyPayment * newPayoffMonths - principalBalance)
  );
  const additionalMonthlyFunds = round(newMonthlyPayment - currentPayment);

  return {
    currentPayoffYears,
    newPayoffYears,
    currentInterestCost,
    newInterestCost,
    totalInterestSavings,
    additionalMonthlyFunds,
    error: null,
  };
}

export default earlyPayoffCalculator;
